<template>
  <node-view-wrapper class="raw-html-block-wrapper" :draggable="true">
    <div class="raw-html-block-wrapper__header">
      <span class="raw-html-block-wrapper__label">Raw HTML Block</span>
      <button
        class="raw-html-block-wrapper__edit-btn"
        @click="openEditor"
        title="Edit raw HTML"
      >
        Edit HTML
      </button>
    </div>
    <!-- Read-only preview of the raw HTML content -->
    <div
      class="raw-html-block-wrapper__preview"
      v-html="node.attrs.rawHtml"
    />

    <!-- Inline editing modal for raw HTML source -->
    <a-modal
      v-model:open="isEditing"
      title="Edit Raw HTML"
      width="800px"
      @ok="saveHtml"
      @cancel="isEditing = false"
      okText="Apply"
    >
      <textarea
        v-model="editBuffer"
        class="raw-html-block-wrapper__textarea"
        spellcheck="false"
        aria-label="Raw HTML block source"
      />
    </a-modal>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper } from '@tiptap/vue-3';

export default {
  components: { NodeViewWrapper },
  props: {
    node: { type: Object, required: true },
    updateAttributes: { type: Function, required: true },
  },
  data() {
    return {
      isEditing: false,
      editBuffer: '',
    };
  },
  methods: {
    openEditor() {
      this.editBuffer = this.node.attrs.rawHtml;
      this.isEditing = true;
    },
    saveHtml() {
      this.updateAttributes({ rawHtml: this.editBuffer });
      this.isEditing = false;
    },
  },
};
</script>

<style lang="scss">
.raw-html-block-wrapper {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  margin: 8px 0;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 10px;
    background: #f5f5f5;
    border-bottom: 1px solid #e8e8e8;
  }

  &__label {
    font-size: 11px;
    font-weight: 600;
    color: #8c8c8c;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  &__edit-btn {
    font-size: 12px;
    padding: 2px 8px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    background: #fff;
    color: #595959;
    cursor: pointer;

    &:hover {
      border-color: #1890ff;
      color: #1890ff;
    }
  }

  &__preview {
    padding: 12px;
    pointer-events: none;
    opacity: 0.85;
    max-height: 400px;
    overflow: auto;
  }

  &__textarea {
    width: 100%;
    height: 400px;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    background: #1e1e1e;
    color: #d4d4d4;
    padding: 12px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    resize: vertical;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
</style>
